<template>
  <b-layout :colors="$site.colors" :header-title="$t('pages.customer.login.email.title')" :header-back-route="homeRoute">
    <b-container class="mt-12">
      <div class="max-w-sm mx-auto">
        <b-errors :errors="errors" />

        <b-card
          v-if="loggingIn"
          title="Logging in"
          class="mb-4"
        >
          <p class="text-secondary text-center mb-2">{{ $t('pages.customer.login.email.loggingIn') }}</p>

          <div class="text-center">
            <b-spinner label="Loading" />
          </div>
        </b-card>


        <b-card
          v-if="loggedIn"
          :title="$t('pages.customer.login.email.hiUser',{user: $auth.user ? $auth.user.firstName : ''})"
          class="mb-4"
        >
        <p class="text-secondary text-center mb-2">{{ $t('pages.customer.login.email.loggedIn') }}</p>

          <div class="text-center">
            <b-spinner class="m-3" />
          </div>

          <div class="text-sm text-secondary">
            {{ $t('pages.customer.login.email.ifNotRedirected') }}
            <nuxt-link :to="redirect" class="text-primary">
              {{ $t('pages.customer.login.email.clickHere') }}
            </nuxt-link>
          </div>
        </b-card>
      </div>
    </b-container>
  </b-layout>
</template>

<script>
import LayoutMixin from '@/mixins/layout'

export default {
  middleware: ['location'],
  meta: {
    tabs: ['user']
  },
  mixins: [LayoutMixin],
  data() {
    return {
      errors: null,
      loggedIn: false,
      loggingIn: false,
      redirect: null
    }
  },
  computed: {
    homeRoute() {
      return this.$store.getters.homeRoute || { path: '/' }
    }
  },
  async mounted() {
    const query = this.$route.query

    this.loggingIn = true
    this.redirect = query.redirect

    if (query.email && query.code && query.auth) {
      await this.$auth.loginWith('location', this.$site.location, { email: query.email, code: query.code, auth: query.auth, expires: query.expires ?? null }).then(() => {
        this.loggedIn = true
        this.loggingIn = false

        this.$router.push((this.redirect) ? this.redirect : { path: '/customer' })
      }).catch(({ result, errors, customer }) => {
        this.loggingIn = false
        if (result === 'expired') {
          this.$router.push({ path: '/customer/login/expired', query: { email: query.email, code: query.code, auth: query.auth, expires: query.expires ?? null, redirect: this.redirect }})
        } else {
          this.errors = errors
        }
      })
    }
  }
}
</script>
